//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: () => ({
    expanded: false
  }),
  computed: {
    classes () {
      return {
        LabelledFrameTypeSelect: true,
        'LabelledFrameTypeSelect--expanded': this.expanded
      }
    }
  },
  methods: {
    toggleConversionKit (state) {
      this.expanded = false
      this.$emit('toggle-conversion-kit', state)
    },
    changeFrameType (frameType) {
      this.expanded = false
      this.$emit('change-frame-type', frameType)
    }
  }
}
